import { ConditionType } from "@soft-db/monitoring-api-client";

export function useConditionTypeLabel() {
	const { t } = useI18n();

	return (type: ConditionType) => {
		switch (type) {
			case "record":
				return t("alert-settings.intervalData");
			case "vibration_event":
				return t("alert-settings.vibrationEvent");
			case "weekly_limit":
				return t("common.weeklyLimit");
		}
	};
}
